import { memo, SVGProps } from 'react';

const SvgIcoGlobe = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
    <g id="globe-02">
      <path
        id="Icon"
        d="M15.9998 2.6665C19.3349 6.31764 21.2302 11.0559 21.3332 15.9998C21.2302 20.9438 19.3349 25.682 15.9998 29.3332M15.9998 2.6665C12.6648 6.31764 10.7695 11.0559 10.6665 15.9998C10.7695 20.9438 12.6648 25.682 15.9998 29.3332M15.9998 2.6665C8.63604 2.6665 2.6665 8.63604 2.6665 15.9998C2.6665 23.3636 8.63604 29.3332 15.9998 29.3332M15.9998 2.6665C23.3636 2.6665 29.3332 8.63604 29.3332 15.9998C29.3332 23.3636 23.3636 29.3332 15.9998 29.3332M3.3332 11.9998H28.6665M3.33317 19.9998H28.6665"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
const Memo = memo(SvgIcoGlobe);
export default Memo;
